import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ProjectActions } from '@/store/modules/project';
    import ProjectListTable from '@/components/project/ProjectListTable';
    import { useStore } from 'vuex';
    import { onMounted } from 'vue';

    
    import { defineComponent } from 'vue';

    const __default__ = defineComponent({
        name:"ProjectList",
    });


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

    const store = useStore();

    onMounted(async () => {
        await store.dispatch(`project/${ProjectActions.asyncGetProjectList}`);
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ProjectListTable)))
}
}

})